import { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { VerticalProgress } from "./ui/vertical-progress";

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const getStepFromPath = (path: string): number => {
    switch (path) {
      case "/":
        return 0; // Landing page - not part of the main flow
      case "/account-authorization":
        return 1; // Account authorization step (HubSpot + Veracross)
      case "/veracross-credentials":
        return 1; // Still part of account authorization - Veracross credentials
      case "/applicant-field-mapping":
        return 2;
      case "/parent-field-mapping":
        return 3;
      case "/application-field-mapping":
        return 4;
      case "/sync-rule-configuration":
        return 5;
      case "/complete":
        return 6;
      default:
        return 1;
    }
  };

  const currentStep = getStepFromPath(location.pathname);

  const steps = [
    {
      number: 1,
      title: "Account authorization",
      path: "/account-authorization",
    },
    { number: 2, title: "Applicant mapping", path: "/applicant-field-mapping" },
    {
      number: 3,
      title: "Parent mapping",
      path: "/parent-field-mapping",
    },
    {
      number: 4,
      title: "Application mapping",
      path: "/application-field-mapping",
    },
    {
      number: 5,
      title: "Sync rules",
      path: "/sync-rule-configuration",
    },
    { number: 6, title: "Complete", path: "/complete" },
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-card shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-foreground">
                Connecting Veracross to HubSpot
              </h1>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content with Vertical Progress */}
      <div className="flex max-w-7xl mx-auto">
        {/* Vertical Progress Bar */}
        <div className="w-64 bg-card border-r border-border min-h-screen">
          <div className="p-6">
            <VerticalProgress steps={steps} currentStep={currentStep} />
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 p-8">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
